import * as React from 'react';

import { Calendar } from '@/components/ui';

import {
    createFamily,
    withStorySources
} from './helpers';

const DEMO_TIMEZONE = 'Europe/Lisbon';
const DEMO_MIN_DATE = '2020-01-01';
const DEMO_MAX_DATE = '2026-04-16';

const SingleHero = () => {
    const [value, setValue] = React.useState('2026-03-15');

    return (
        <Calendar
            maxDate={DEMO_MAX_DATE}
            minDate={DEMO_MIN_DATE}
            mode="single"
            onChange={setValue}
            timezone={DEMO_TIMEZONE}
            value={value}
        />
    );
};

const RangeHero = () => {
    const [value, setValue] = React.useState({ start: '2026-01-01', finish: '2026-03-15' });

    return (
        <Calendar
            maxDate={DEMO_MAX_DATE}
            minDate={DEMO_MIN_DATE}
            mode="range"
            onChange={setValue}
            shortcuts
            timezone={DEMO_TIMEZONE}
            value={value}
        />
    );
};

const ShiftableRangeHero = () => {
    const [value, setValue] = React.useState({ start: '2026-01-01', finish: '2026-03-15' });

    return (
        <Calendar
            maxDate={DEMO_MAX_DATE}
            minDate={DEMO_MIN_DATE}
            mode="range"
            onChange={setValue}
            shiftable
            shortcuts
            timezone={DEMO_TIMEZONE}
            value={value}
        />
    );
};

const calendarStorySections = [
    createFamily({
        id: 'calendar',
        label: 'Calendar',
        description: 'Date picker with popover, supporting single date and range selection with optional shortcuts and period shift.',
        subcomponents: ['Calendar'],
        stories: [
            {
                id: 'calendar-single',
                title: 'Single date picker',
                hero: SingleHero
            },
            {
                id: 'calendar-range',
                title: 'Range with shortcuts',
                hero: RangeHero
            },
            {
                id: 'calendar-range-shiftable',
                title: 'Range with shift buttons',
                hero: ShiftableRangeHero
            }
        ]
    })
].map(withStorySources);

export { calendarStorySections };
